import { BaseApiClient } from '../client'
import type {
  Merchant,
  User,
  CreateMerchantPayload,
  CreateUserPayload,
  CreateResponse,
} from '../types'

export class BackofficeApi extends BaseApiClient {
  async getMerchants() {
    return this.request<Merchant[]>('/api/admin/backoffice/merchants')
  }

  async getUsers() {
    return this.request<User[]>('/api/admin/backoffice/users')
  }

  async createMerchant(data: CreateMerchantPayload) {
    return this.request<CreateResponse>('/api/admin/backoffice/merchants', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async createUser(data: CreateUserPayload) {
    return this.request<CreateResponse>('/api/admin/setup/create-admin', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async deleteUser(id: string) {
    return this.request<{ success: true; message: string }>(`/api/admin/backoffice/users/${id}`, {
      method: 'DELETE',
    })
  }
}
